import { render, staticRenderFns } from "./AuthenticationComplete.vue?vue&type=template&id=e2536630&scoped=true&"
import script from "./AuthenticationComplete.vue?vue&type=script&lang=js&"
export * from "./AuthenticationComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2536630",
  null
  
)

export default component.exports